angular.module("UI8.components").component("productCard", {
  template:
    '<div class="product ng-cloak" on-load="$ctrl.attachClickHandler()" ng-class="{\'active\': $ctrl.drawerActive}">' +
    '  <div class="product__bg">' +
    '    <img ng-src="{{$ctrl.cardImage}}" loading="lazy" alt="{{$ctrl.product.name}}">' +
    "  </div>" +
    '  <div class="product__preview">' +
    '    <div class="product__media">' +
    '      <img ng-src="{{$ctrl.cardImage}}" loading="lazy" alt="{{$ctrl.product.name}}" ui8-fade-in>' +
    "    </div>" +
    '    <div class="product__over">' +
    '      <div class="product__like">' +
    '        <button class="product__btn" ng-class="{active: $ctrl.isLiked($ctrl.product._id)}" ng-if="$ctrl.user" ng-click="$ctrl.likeProduct($ctrl.product._id)">' +
    "          <span>{{$ctrl.likeCount($ctrl.product._id, $ctrl.product.likes)}}</span>" +
    '          <svg><path d="M21 10c0 5.75-8.25 10-9 10s-9-4.25-9-10c0-4 2.5-6 5-6s4 1.5 4 1.5S13.5 4 16 4s5 2 5 6Z"/></svg>' +
    "        </button>" +
    '        <a class="product__btn" ng-if="!$ctrl.user" href="/account/signup">' +
    "          <span>{{$ctrl.likeCount($ctrl.product._id, $ctrl.product.likes)}}</span>" +
    '          <svg><path d="M21 10c0 5.75-8.25 10-9 10s-9-4.25-9-10c0-4 2.5-6 5-6s4 1.5 4 1.5S13.5 4 16 4s5 2 5 6Z"/></svg>' +
    "        </a>" +
    "      </div>" +
    '      <a class="product__btn" ng-if="!$ctrl.drawer" ng-href="{{$ctrl.productLink}}">' +
    '        <svg><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/><path d="M21.498 11.095c-4.838-8.127-14.158-8.127-18.995 0a1.77 1.77 0 0 0 0 1.81c4.837 8.127 14.157 8.127 18.995 0a1.77 1.77 0 0 0 0-1.81"/></svg>' +
    "      </a>" +
    '      <button class="product__btn" ng-if="$ctrl.drawer" ng-click="$ctrl.handleDrawerClick($event)">' +
    '        <svg><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/><path d="M21.498 11.095c-4.838-8.127-14.158-8.127-18.995 0a1.77 1.77 0 0 0 0 1.81c4.837 8.127 14.157 8.127 18.995 0a1.77 1.77 0 0 0 0-1.81"/></svg>' +
    "      </button>" +
    '      <button class="product__btn" ng-if="(!$ctrl.drawer && $ctrl.user && ($ctrl.user.pass_holder || $ctrl.userHasLifetime) && $ctrl.product.type !== \'bundle\' && ($ctrl.product | ui8Deliverables) && $ctrl.product.price)" ng-click="$ctrl.toggleDownloadModal()">' +
    '        <svg><path d="M3 17c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.121 2.121C5.605 21 6.07 21 7 21h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C21 18.395 21 17.93 21 17m-4.5-5.5S13.186 16 12 16s-4.5-4.5-4.5-4.5M12 15V3"/></svg>' +
    "      </button>" +
    '      <button class="product__btn" ng-if="(!$ctrl.drawer && $ctrl.user && $ctrl.product.type !== \'bundle\' && ($ctrl.product | ui8Deliverables) && !$ctrl.product.price)" ng-click="$ctrl.toggleDownloadModal()">' +
    '        <svg><path d="M3 17c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.121 2.121C5.605 21 6.07 21 7 21h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C21 18.395 21 17.93 21 17m-4.5-5.5S13.186 16 12 16s-4.5-4.5-4.5-4.5M12 15V3"/></svg>' +
    "      </button>" +
    '      <a class="product__btn" ng-if="(!$ctrl.drawer && !$ctrl.user && $ctrl.product.type !== \'bundle\' && ($ctrl.product | ui8Deliverables) && !$ctrl.product.price)" href="/account/signup">' +
    '        <svg><path d="M3 17c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.121 2.121C5.605 21 6.07 21 7 21h10c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C21 18.395 21 17.93 21 17m-4.5-5.5S13.186 16 12 16s-4.5-4.5-4.5-4.5M12 15V3"/></svg>' +
    "      </a>" +
    '      <button class="product__btn" ng-if="((!$ctrl.user || $ctrl.user.role === \'admin\' || ($ctrl.user && !$ctrl.user.pass_holder)) && $ctrl.product.price && !$ctrl.product.subscription_product && !$ctrl.user.pass_holder)" data-partial="angular_card" data-id="{{$ctrl.product.base_subscription_id || $ctrl.product._id}}" ng-click="$ctrl.addToCart($event)">' +
    '        <svg><path d="M16 8a4 4 0 1 1-8 0m-4.367-.599-.7 8.4c-.15 1.805-.226 2.707.08 3.403a3 3 0 0 0 1.319 1.434C5 21 5.905 21 7.716 21h8.567c1.81 0 2.716 0 3.384-.362a3 3 0 0 0 1.32-1.434c.305-.696.23-1.598.08-3.403l-.7-8.4c-.13-1.552-.195-2.329-.539-2.916a3 3 0 0 0-1.294-1.191C17.92 3 17.141 3 15.583 3H8.416c-1.558 0-2.337 0-2.95.294a3 3 0 0 0-1.295 1.19c-.344.588-.409 1.365-.538 2.917"/></svg>' +
    "      </button>" +
    '      <button class="product__btn" ng-if="$ctrl.product.subscription_product && !$ctrl.userHasLifetime" ui8-toggle-class="pass-pricing-modal">' +
    '        <svg><path d="M16 8a4 4 0 1 1-8 0m-4.367-.599-.7 8.4c-.15 1.805-.226 2.707.08 3.403a3 3 0 0 0 1.319 1.434C5 21 5.905 21 7.716 21h8.567c1.81 0 2.716 0 3.384-.362a3 3 0 0 0 1.32-1.434c.305-.696.23-1.598.08-3.403l-.7-8.4c-.13-1.552-.195-2.329-.539-2.916a3 3 0 0 0-1.294-1.191C17.92 3 17.141 3 15.583 3H8.416c-1.558 0-2.337 0-2.95.294a3 3 0 0 0-1.295 1.19c-.344.588-.409 1.365-.538 2.917"/></svg>' +
    "      </button>" +
    '      <a ng-if="!$ctrl.drawer" ng-href="{{$ctrl.productLink}}" class="product__link"></a>' +
    '      <button ng-if="$ctrl.drawer" class="product__link" ng-click="$ctrl.handleDrawerClick($event)"></button>' +
    "    </div>" +
    "  </div>" +
    '  <div class="product__inner">' +
    '    <div class="product__head">' +
    '      <a class="product__title" ng-href="{{$ctrl.productLink}}">{{$ctrl.product.name}}</a>' +
    '      <div class="product__price" ng-if="$ctrl.product.price">' +
    '        <span class="product__full" ng-if="$ctrl.product.seasonal_promo_enabled && $ctrl.product.site_promo && !$ctrl.pass">{{$ctrl.product.price | ui8Currency}}</span>' +
    "        <span ng-if='!$ctrl.product.subscription_product'>{{($ctrl.product.seasonal_promo_enabled && $ctrl.product.site_promo ? $ctrl.product.seasonal_promo_price : $ctrl.product.price) | ui8Currency}}</span>" +
    "        <span ng-if='$ctrl.product.subscription_product'><span class='product__from'>from</span> {{$ctrl.passFrom}}</span>" +
    "      </div>" +
    '      <div class="product__price" ng-if="!$ctrl.product.price">Free</div>' +
    "    </div>" +
    '    <div class="product__meta">' +
    '      <div class="product__author" ng-if="$ctrl.product.author && !$ctrl.product.is_subscription">' +
    '        <a class="product__avatar" ng-href="/{{$ctrl.product.author.display_name_slug || $ctrl.product.author._id}}/products" ui8-resize-to="{{$ctrl.resizeAvatarTo}}" ui8-image="{{$ctrl.authorAvatar}}"></a>' +
    '        <a ng-href="/{{$ctrl.product.author.display_name_slug || $ctrl.product.author._id}}/products">{{$ctrl.product.author.display_name ? $ctrl.product.author.display_name : ($ctrl.product.author.first_name + " " + $ctrl.product.author.last_name)}}</a>' +
    "      </div>" +
    '      <div class="product__arrow" ng-if="$ctrl.product.category.length && !$ctrl.product.is_subscription"></div>' +
    '      <div class="product__category" ng-if="$ctrl.product.category.length && !$ctrl.product.is_subscription">' +
    '        <a ng-href="/categories/{{$ctrl.product.category[0].slug}}">{{$ctrl.product.category[0].name}}</a>' +
    "      </div>" +
    "      <div class='product__unlock' ng-if='$ctrl.product.subscription_product'><svg width='15' height='15' viewBox='0 0 24 24'><path d='M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z'/></svg>Unlock everything</div>" +
    '      <div class="product__featured" ng-class="{\'has-dna\': $ctrl.product.hasDesignDna}" ng-if="$ctrl.product.featured && !$ctrl.product.subscription_product"><span>Featured product</span></div>' +
    '      <div class="product__dna" ng-if="$ctrl.product.hasDesignDna"><div><span class="dna-icon">AI-Ready</span></div></div>' +
    "    </div>" +
    "  </div>" +
    '  <download-modal ng-if="$ctrl.showDownloadModal" product="$ctrl.product" display="$ctrl.showDownloadModal" freebie="$ctrl.product.freebie || !$ctrl.product.price"></download-modal>' +
    "</div>",

  controller: function (
    LikeService,
    CartService,
    $element,
    $rootScope,
    $location
  ) {
    var $ctrl = this;

    // Cart
    this.addToCart = function (e) {
      if ($rootScope.showSearch) {
        var name = $ctrl.product ? $ctrl.product.name : "";
        CartService.addToCart(e, function (err) {
          $rootScope.$broadcast("search:cart-added", {
            name: name,
            message: err,
            isError: !!err,
          });
        });
      } else {
        $rootScope.showSearch = false;
        CartService.addToCart(e);
      }
    };

    // Likes
    this.isLiked = LikeService.isLiked;
    this.unLiked = LikeService.unLiked;
    this.likeProduct = LikeService.toggleLike;
    this.getCountModifier = LikeService.getCountModifier;
    this.likeCount = LikeService.likeCount;

    this.showDownloadModal = false;
    this.movedModal = false;

    this.$onInit = function () {
      this.userHasLifetime = window.UI8.userHasLifetime;
      // "from" price on the pass card: the seasonal sale sells Basic at $112,
      // otherwise the cheapest card in the pass modal (Pro, 3 months)
      this.passFrom = (function () {
        if (window.UI8.currentSale) return "$112";
        var pro3 = (window.UI8.subscriptions || []).find(function (s) {
          return s.slug === "pass-pro-3month";
        });
        return "$" + (pro3 ? pro3.price / 100 : 129);
      })();
      const resolution = { width: 604, height: 420 };

      const avatarResolution = { width: 40, height: 40 };

      const S3_IMAGE_SERVER = "https://images.ui8.net";

      if (this.product.has_resized_card_image) {
        const postfix = this.product.card_image_version
          ? `_${this.product.card_image_version}`
          : "";
        this.cardImage = `${S3_IMAGE_SERVER}/product/${this.product._id}/${resolution.width}_${resolution.height}${postfix}.webp`;
      } else {
        this.cardImage = this.product.card_image;
      }

      if (this.product.author.has_resized_avatar) {
        const postfix = this.product.author.avatar_url_version
          ? `_${this.product.author.avatar_url_version}`
          : "";
        this.authorAvatar = `${S3_IMAGE_SERVER}/avatar/${this.product.author._id}/${avatarResolution.width}_${avatarResolution.height}${postfix}.png`;
        this.resizeAvatarTo = "";
      } else {
        this.authorAvatar =
          this.product.author.avatar_url ||
          "//d1v8dk3ka6obgr.cloudfront.net/v5/assets/global/default_avatar_v2.png";
        this.resizeAvatarTo = `width=${avatarResolution.width},height=${avatarResolution.height}`;
      }

      var productLink = "/";

      if (!this.product.permalink) {
        if (
          this.product.slug !== "all-access-pass" &&
          this.product.author &&
          this.product.author.display_name_slug
        ) {
          productLink += this.product.author.display_name_slug + "/";
        }

        productLink += "products/" + this.product.slug;

        if (this.linkQuery) {
          productLink += this.linkQuery;
        }

        this.productLink = productLink;
      } else {
        this.productLink = this.product.permalink;
      }
    };

    this.toggleDownloadModal = function () {
      this.showDownloadModal = !this.showDownloadModal;

      if (!this.movedModal) {
        this.movedModal = true;

        setTimeout(function () {
          $("download-modal").appendTo("body");
        }, 0);
      }
    };

    this.attachClickHandler = function () {
      $element
        .find(".product__meta a, .product__like a")
        .on("click", function () {
          if (!$rootScope.showSearch) return;

          window.scrollLock.enablePageScroll();
          $("body").css("overflow-y", "scroll");

          $rootScope.showSearch = false;
          $location.search("search", null);
        });
    };

    this.handleDrawerClick = function (e) {
      if (e && (e.metaKey || e.ctrlKey)) {
        window.open(this.productLink, "_blank");
        return;
      }
      if (this.onDrawerOpen) this.onDrawerOpen({ product: this.product });
    };

    this.$destroy = function () {
      $element.find(".product__meta a, .product__like a").off();
    };
  },

  bindings: {
    product: "<",
    user: "<",
    pass: "<?",
    linkQuery: "<?",
    drawer: "<?",
    drawerActive: "<?",
    onDrawerOpen: "&?",
  },
});
